import React, { useState, useCallback } from 'react';
import { ButtonProps, DialogProps as MuiDialogProps } from '@material-ui/core';

type PartialMuiDialogProps = Partial<MuiDialogProps>; // makes 'open' props optional

interface IConfirmProps extends ButtonProps {
    onConfirm: (...args: any[]) => void
    confirmText: string
};

interface IDialogProps {
    dialogTitle: React.ReactElement | string
    dialogContent: React.ReactElement | string
    dialogConfirm: IConfirmProps,
    muiDialogProps?: PartialMuiDialogProps
};

const initDialog: IDialogProps = {
    dialogTitle: "Подтвреждение",
    dialogContent: "Подтвердите",
    dialogConfirm: {
        onConfirm: () => {},
        confirmText: "ОК"
    },
};

interface IDialogContext {
    dialog: IDialogProps | null
    addDialog: (dialog: IDialogProps) => void
    closeDialog: () => void
};

const context: IDialogContext = {
    dialog: initDialog,
    addDialog: (dialogProps: IDialogProps) => {},
    closeDialog: () => {}
};

export const DialogContext = React.createContext(context);

const DialogProvider: React.FC<{}> = ({ children }) => {
  const [dialog, setDialog] = useState<IDialogProps | null>(null);

  const closeDialog = () => setDialog(null);

  const addDialog = (dialogProps: IDialogProps) => setDialog(dialogProps);

  const contextValue: IDialogContext = {
    dialog,
    addDialog: useCallback((dialog: IDialogProps) => addDialog(dialog), []),
    closeDialog: useCallback(() => closeDialog(), [])
  };

  return (
    <DialogContext.Provider value={contextValue}>
      {children}
    </DialogContext.Provider>
  );
};

export default DialogProvider;